let ctx = null;
const getCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  return ctx;
};

const tone = (freq, dur, { type = "sine", gain = 0.08, slide = 0, delay = 0 } = {}) => {
  const c = getCtx();
  const t = c.currentTime + delay;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t);
  if (slide) o.frequency.exponentialRampToValueAtTime(freq * slide, t + dur);
  g.gain.setValueAtTime(gain, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(c.destination);
  o.start(t);
  o.stop(t + dur);
};

export const SFX = {
  plant: () => { tone(220, 0.12, { type: "triangle", slide: 0.6 }); tone(330, 0.1, { type: "triangle", delay: 0.06 }); },
  harvest: () => [523, 659, 784, 1046].forEach((f, i) => tone(f, 0.18, { type: "square", gain: 0.05, delay: i * 0.07 })),
  clear: () => tone(140, 0.25, { type: "sawtooth", gain: 0.05, slide: 0.5 }),
  unlock: () => [392, 523, 784].forEach((f, i) => tone(f, 0.2, { type: "triangle", delay: i * 0.09 })),
  coin: () => { tone(988, 0.08, { type: "square", gain: 0.04 }); tone(1319, 0.2, { type: "square", gain: 0.04, delay: 0.08 }); },
  error: () => tone(160, 0.2, { type: "square", gain: 0.04, slide: 0.8 }),
  levelUp: () => [523, 659, 784, 1046, 1318].forEach((f, i) => tone(f, 0.22, { type: "triangle", delay: i * 0.1 })),
};

export const play = (enabled, name) => {
  if (!enabled) return;
  try { SFX[name]?.(); } catch { /* audio unavailable */ }
};
